import apiBranch from '@/api/branch'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  createBranchStart: '[create branch] Create branch start',
  createBranchSuccess: '[create branch] Create branch success',
  createBranchFailure: '[create branch] Create branch failure',
}

export const actionTypes = {
  branchCreate: '[create branch] Create branch',
  createBranches: '[create branch] Create branches',
}

const mutations = {
  [mutationTypes.createBranchStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.createBranchSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createBranchFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.branchCreate](context, {branch}) {
    context.commit(mutationTypes.createBranchStart)
    return new Promise((resolve) => {
      apiBranch
        .createBranch(branch)
        .then((response) => {
          context.commit(mutationTypes.createBranchSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.createBranchFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.createBranches](context, {branches}) {
    context.commit(mutationTypes.createBranchStart)

    return new Promise((resolve) => {
      const createBranches = async (branches) => {
        for (const branch of branches) {
          await context.dispatch(actionTypes.branchCreate, {branch})
        }
      }

      createBranches(branches)
        .then((response) => {
          context.commit(mutationTypes.createBranchSuccess)
          resolve(response)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.createBranchFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
